import type { ChapterContent, ContentBlock } from '../../types';

/**
 * Merges consecutive/all chapters that require the same expansion addon
 * into one long scrollable chapter with H1 headings from former titles.
 */
export function consolidateAddonChapters(
  chapters: ChapterContent[],
  addonId: string,
  hubTitle: string
): ChapterContent[] {
  const parts = chapters.filter((chapter) =>
    chapter.requiredAddons?.includes(addonId)
  );
  if (parts.length <= 1) return chapters;

  const rest = chapters.filter(
    (chapter) => !chapter.requiredAddons?.includes(addonId)
  );
  const content: ContentBlock[] = [];
  for (const part of parts) {
    const heading = part.title
      .replace(new RegExp(`^${hubTitle}\\s*[—–-]\\s*`, 'i'), '')
      .replace(/^\d+\.\s*/, '')
      .trim();
    content.push({
      type: 'heading',
      text: heading || part.title,
      level: 1,
    });
    content.push(...part.content);
  }

  const hub: ChapterContent = {
    title: hubTitle,
    requiredAddons: [addonId],
    content,
  };

  // Keep hub where the first expansion chapter originally appeared.
  const firstIndex = chapters.findIndex((chapter) =>
    chapter.requiredAddons?.includes(addonId)
  );
  if (firstIndex < 0) return [...rest, hub];
  const before = chapters
    .slice(0, firstIndex)
    .filter((chapter) => !chapter.requiredAddons?.includes(addonId));
  const after = chapters
    .slice(firstIndex + 1)
    .filter((chapter) => !chapter.requiredAddons?.includes(addonId));
  return [...before, hub, ...after];
}
